import React from "react";
import { MOST_RECENT_GA_VERSION } from "@plugins/gatsby-source-paligo/src/config";
import { box } from "@singlestore/fusion/components/layout";

import { Admonition } from "components/Admonition/Admonition";
import { Link } from "components/Link/Link";
import { Paragraph } from "components/Paragraph/Paragraph";

if (!MOST_RECENT_GA_VERSION) {
    throw new Error(
        "No GA version found in ACTIVE_VERSIONS. Please check the configuration."
    );
}

type RcWarningProps = {
    versionName: string;
};

export function RcWarning({ versionName }: RcWarningProps) {
    return (
        <Admonition className={box({ mb: "2x" })} type="warning">
            <Paragraph variant="body-3">
                SingleStore {versionName} gives you the opportunity to preview,
                evaluate, and provide feedback on new and upcoming features
                prior to their general availability. In the interim,{" "}
                <Link to={`/db/v${MOST_RECENT_GA_VERSION!.name}/`}>
                    SingleStore {MOST_RECENT_GA_VERSION!.name}
                </Link>{" "}
                is recommended for production workloads, which can later be
                upgraded to SingleStore {versionName}.
            </Paragraph>
        </Admonition>
    );
}
